module.exports = __webpack_public_path__ + "img/7.871def7c.png";